import { Redirect } from "@-/com.npmjs.expo-router";
import { Platform } from "@-/com.npmjs.react-native";
import {
  useLocalAccount,
  useRecordSessionAccountEmail,
} from "@-/dev.improve.haniverse.lib.auth.client";
import { useAuthPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.auth.navigator";
import type { PropsWithChildren } from "react";

/**
 * The native app is only entered with a local account, i.e. a known email (see `useLocalAccount`).
 * Every way in passes through here (the startup redirect, deep links, the welcome gate's entry,
 * restoring a session), so a device without one is sent to the welcome gate instead of an app
 * whose drawer has no account to show. Losing the email, which only sign-out does, sends the app
 * back there too.
 *
 * Web is a public dictionary site, not an app shell: its routes stay open to visitors without an
 * account, and it has no account drawer.
 */
export function AppLocalAccountGate({ children }: PropsWithChildren) {
  const localAccount = useLocalAccount();
  useRecordSessionAccountEmail();
  const authPageNavigator = useAuthPageNavigator();

  if (localAccount === null && Platform.OS !== "web") {
    return <Redirect href={authPageNavigator.resolveHref()} />;
  }
  return children;
}
